import { useDocumentContext } from '../../documents/documentContext/DocumentContext.tsx';
import { QueryFactory } from 'services/api';
import { queryClient } from 'services/api/query-client-helper.ts';
import { useVariablesContext } from '../variablesContext/VariablesContext.tsx';

export const useHandleErrorOnFetchVariable = () => {
  const { setDocumentState } = useDocumentContext();
  const { refreshVariables } = useVariablesContext();

  return async (props: {
    error: any;
    documentsIds: number[];
    revisionId: number;
    onVariableUpdate: () => Promise<void>;
  }) => {
    if (props.error.status !== 404) return;

    await props.onVariableUpdate();

    await Promise.all([
      ...props.documentsIds.map((docId) =>
        queryClient.invalidateQueries({
          queryKey: QueryFactory.DocumentQuery.getQueryKey(docId),
        }),
      ),
      queryClient.invalidateQueries({
        queryKey: QueryFactory.DocumentQuery.searchQueryKey({
          revisionId: props.revisionId,
        }),
      }),
      refreshVariables(),
    ]);

    setDocumentState((prev) => ({
      ...prev,
      enableDocumentUpdate: true,
    }));
  };
};
